type AudioContextCtor = typeof AudioContext;

/**
 * A short two-note "ta-da" flourish for the accusation button — pure
 * atmosphere for the face-to-face table. Synthesised with the Web Audio API so
 * the PWA ships no audio asset and makes no network request. Best-effort: any
 * failure (unsupported browser, blocked autoplay) is silently ignored.
 */
export function playAccuseSound(): void {
  try {
    const Ctor: AudioContextCtor | undefined =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: AudioContextCtor })
        .webkitAudioContext;
    if (Ctor === undefined) {
      return;
    }
    const ctx = new Ctor();
    const now = ctx.currentTime;
    const notes: readonly [number, number][] = [
      [660, 0],
      [988, 0.12]
    ];
    for (const [frequency, offset] of notes) {
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();
      oscillator.type = "triangle";
      oscillator.frequency.value = frequency;
      gain.gain.setValueAtTime(0.0001, now + offset);
      gain.gain.exponentialRampToValueAtTime(0.25, now + offset + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + offset + 0.2);
      oscillator.connect(gain).connect(ctx.destination);
      oscillator.start(now + offset);
      oscillator.stop(now + offset + 0.22);
    }
    window.setTimeout(() => void ctx.close(), 700);
  } catch {
    // Optional flourish — ignore failures.
  }
}
